module.exports = __webpack_public_path__ + "static/media/pythonForEverybody.0e49945d.jpg";